export function isWkwebview() {
  return window.__wxjs_is_wkwebview;
}

export function changeTitle(title) {
  document.title = title;
}

export function queryObject() {
  try {
    const search = window.location.search.substring(1);
    if (!search || !search.length) {
      return {};
    }
    return JSON.parse(`{"${decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
  } catch (e) {
    console.warn(e);
    return {};
  }
}

export function isIPhoneX() {
  // Really basic check for the ios platform
  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
  const iOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;

  // Get the device pixel ratio
  const ratio = window.devicePixelRatio || 1;

  // Define the users device screen dimensions
  const screen = {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio,
  };

  // iPhone X Detection
  return (iOS && screen.width === 1125 && screen.height === 2436);
}



// WEBPACK FOOTER //
// ./src/util.js